import { boardItems } from "@/mocks/home";

const accentMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600",
  secondary: "bg-secondary-100 text-secondary-700",
  accent: "bg-accent-100 text-accent-600",
};

export default function Boards() {
  return (
    <section id="boards" className="scroll-mt-20 border-t border-background-200/70 bg-background-100/40">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mb-10 max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-secondary-700">
            <i className="ri-layout-grid-line"></i>
            社区板块
          </span>
          <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            找一个你感兴趣的地方坐坐
          </h2>
          <p className="mt-3 text-base text-foreground-600">
            分区清晰、氛围友好，按你最近在追的话题挑一个板块，和大家一起聊个痛快。
          </p>
        </div>

        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {boardItems.map((b) => (
            <a
              key={b.id}
              href="#guide"
              className="group flex flex-col justify-between rounded-xl border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-background-300"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-full text-lg ${accentMap[b.accent]}`}>
                    <i className={b.icon}></i>
                  </span>
                  <i className="ri-arrow-right-up-line text-lg text-foreground-300 transition-colors group-hover:text-primary-500"></i>
                </div>
                <h3 className="mt-4 text-lg font-semibold text-foreground-950">{b.name}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{b.desc}</p>
              </div>
              <div className="mt-5 flex items-center gap-4 border-t border-background-200/70 pt-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-user-3-line"></i>
                  {b.members} 成员
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-file-text-line"></i>
                  {b.posts} 讨论
                </span>
              </div>
            </a>
          ))}

          {/* 入口占位卡：加入社区 */}
          <a
            href="#guide"
            className="group flex flex-col justify-between rounded-xl bg-background-800 p-5"
          >
            <div>
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-background-50 text-lg text-primary-600">
                  <i className="ri-user-add-line"></i>
                </span>
                <i className="ri-arrow-right-up-line text-lg text-background-400 transition-colors group-hover:text-background-50"></i>
              </div>
              <h3 className="mt-4 text-lg font-semibold text-background-50">想加入社区？</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-background-300">
                找到你的兴趣板块，从一句友善的发言开始，很快就能融入这里的大部队。
              </p>
            </div>
            <div className="mt-5 flex items-center gap-1.5 border-t border-background-700 pt-4 text-sm font-medium text-background-50">
              看看怎么进
              <i className="ri-arrow-right-line"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}